import React, { useEffect, useState } from 'react';
import IGuest from '@/models/guests/iguest';
import * as guestService from '@/services/guests-service';
import StringComponent from '@/components/forms/string-component';
import TextAreaComponent from '@/components/forms/textarea-component';
import "react-datepicker/dist/react-datepicker.css";
import { toast } from 'react-toastify';
import { GuestHasChanged, GuestHasFormData, GuestHasRequiredFormFields } from "./validation-guest";

interface IProps {
    id?: number;
    isLoading: (isLoading: boolean) => void;
    modelValidation: (hasRequiredFormFields: boolean, hasFormData: boolean, hasChanged: boolean, model: IGuest) => void;
}

const EditGuestComponent: React.FC<IProps> = ({ id, isLoading, modelValidation }) => {
    const [ guest, setGuest] = useState<IGuest>({} as IGuest);
    const [ originalGuest, setOriginlGuest] = useState<IGuest>({} as IGuest);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const guest = await guestService.getGuest(id!);
                
                setGuest(guest);
                setOriginlGuest(guest);
            } catch {
                toast.error("The guest couldn't be loaded for an unknown reason.");
            }

            isLoading(false);
        }

        if (id) {
            fetchData();
        } else {
            isLoading(false);
        }
    }, [])
    
    useEffect(() => {
        modelValidation(
            GuestHasRequiredFormFields(guest),
            GuestHasFormData(guest),
            GuestHasChanged(originalGuest, guest),
            guest
        );
    }, [guest])

    return (
        <>
            <StringComponent
                isAutoFocusElement={true}
                value={guest?.firstName}
                purpose="First Name *"
                newValue={(newValue) => setGuest({...guest, firstName: newValue} as IGuest)}
            />

            <StringComponent
                value={guest?.lastName}
                purpose="Last Name *"
                newValue={(newValue) => setGuest({...guest, lastName: newValue} as IGuest)} 
            />

            <StringComponent
                value={guest?.emailAddress}
                purpose="Email Address"
                newValue={(newValue) => setGuest({...guest, emailAddress: newValue} as IGuest)} 
            />

            <StringComponent
                value={guest?.phoneNumber}
                purpose="Phone Number"
                newValue={(newValue) => setGuest({...guest, phoneNumber: newValue} as IGuest)} 
            />

            <TextAreaComponent
                value={guest?.dietaryRequirements}
                purpose="Dietary Requirements"
                newValue={(newValue) => setGuest({...guest, dietaryRequirements: newValue} as IGuest)} 
            />

            <TextAreaComponent
                value={guest?.notes}
                purpose="Notes about this guest"
                newValue={(newValue) => setGuest({...guest, notes: newValue} as IGuest)} 
            />                           
        </>
    );
}

export default EditGuestComponent;